import { Button, ButtonColor, ButtonSize } from '@mkp/shared/ui-library';

export const HAMBURGER_BUTTON_CONFIG: Button = {
  classList: ['icon-only'],
  color: ButtonColor.Transparent,
  mobileFullWidth: false,
};

export const TOP_HEADER_BUTTON_CONFIG: Button = {
  classList: ['no-bold'],
  color: ButtonColor.Secondary,
  mobileFullWidth: false,
  size: ButtonSize.Medium,
};

export const SUPPORT_CENTER_BUTTON_CONFIG: Button = {
  ...TOP_HEADER_BUTTON_CONFIG,
  size: ButtonSize.Small,
};
